module.exports = __webpack_public_path__ + "img/travel-distance.bea04cbb.svg";